import { Item } from "..";
import { DesignPriceCalculatorRuleBased } from "../../../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased";
import { Integration, PlatformAttributeSelection } from "./Integration";

enum MessageType {
    Close = "Close"
}

export default class MerchantIntegrationPreview implements Integration {

    public constructor() {

    }

    addToCart(composition: any, design: any, model: any, attributes: PlatformAttributeSelection[], designItems: Item[], quantity: number, additionalProperties: Record<string, any>) {
        // Not implemented
    }

    getPrice(composition: any, design: any, model: any, attributes: any, compositionPrice: any, isCustomPricingConfiguratorEnabled: any, isCustomPricingRuleBasedEnabled: any, quantity: number): Promise<{ price: number, isOutOfStock: boolean }> {
        return new Promise<{ price: number, isOutOfStock: boolean }>((resolve, reject) => {
            resolve({
                price: isCustomPricingConfiguratorEnabled ? compositionPrice : 0,
                isOutOfStock: false
            });
        });
    }

    getSharedCompositionUrl(compositionDocID: string) {

        return new Promise<{ url: string }>((resolve, reject) => {

        });
    }

    setPricingCalculator(pricingCalculator: DesignPriceCalculatorRuleBased) {
        // Not implemented
    }

    close() {
        window.parent.postMessage({
            zakekeMessageType: MessageType.Close,
        }, '*');
    }
}
